import "bootstrap";
import { ekkoLightbox } from "ekko-lightbox/dist/ekko-lightbox.min";
import "owl.carousel";

import "./comparison";
import "./shop";
import "./address_dadata";

$(function () {
  // Слайдер с новостями и акциями
  $("#js-header-slider").owlCarousel({
    autoplay: true,
    autoplaySpeed: 0.35,
    loop: true,
    navText: ["", ""],
    navContainerClass: "rd-carousel__nav rd-carousel__nav--third",
    navClass: [
      "rd-carousel__nav__prev  rd-carousel__nav__prev--third",
      "rd-carousel__nav__next  rd-carousel__nav__next--third",
    ],
    navElement: "div",
    dots: false,
    dotsClass: "rd-carousel__dots",
    dotClass: "rd-carousel__dots__item",
    items: 1,
    responsive: {
      0: {
        nav: false,
      },
      768: {
        nav: true,
      },
    },
  });

  // Основной слайдер баннеров
  $("#js-main-slider").owlCarousel({
    autoplay: true,
    autoplaySpeed: 0.7,
    autoplayHoverPause: true,
    animateOut: 'fadeOut',
    loop: true,
    navText: ["", ""],
    navContainerClass: "rd-carousel__nav rd-carousel__nav--primary",
    navClass: ["rd-carousel__nav__prev", "rd-carousel__nav__next"],
    navElement: "div",
    navSpeed: 0.7,
    dots: true,
    dotsClass: "rd-carousel__dots",
    dotClass: "rd-carousel__dots__item",
    items: 1,
    responsive: {
      0: {
        nav: false,
      },
      768: {
        nav: false,
      },
    },
  });

  // Слайдер баннеров
  $("#js-banners-slider").owlCarousel({
    autoplay: true,
    autoplaySpeed: 0.35,
    loop: false,
    rewind: true,
    nav: true,
    navText: ["", ""],
    navContainerClass: "rd-carousel__nav rd-carousel__nav--secondary",
    navClass: [
      "rd-carousel__nav__prev rd-carousel__nav__prev--secondary",
      "rd-carousel__nav__next rd-carousel__nav__next--secondary",
    ],
    navElement: "div",
    dotsClass: "rd-carousel__dots",
    dotClass: "rd-carousel__dots__item",
    items: 1,
    responsive: {
      0: {
        items: 1,
        dots: true,
      },
      768: {
        items: 3,
        margin: 15,
        dots: false,
      },
      992: {
        items: 4,
        margin: 30,
        dots: false,
      },
    },
  });

  // Слайдер категорий товаров
  $("#js-categories-slider").owlCarousel({
    autoplay: false,
    loop: false,
    rewind: true,
    navText: ["", ""],
    navContainerClass: "rd-carousel__nav rd-carousel__nav--primary",
    navClass: ["rd-carousel__nav__prev", "rd-carousel__nav__next"],
    navElement: "div",
    dotsClass: "rd-carousel__dots",
    dotClass: "rd-carousel__dots__item",
    items: 1,
    responsive: {
      0: {
        nav: false,
        dots: true,
      },
      768: {
        nav: true,
        dots: false,
      },
    },
  });

  // Слайдер недавно просмотренных товаров
  $("#js-watchlist-slider").owlCarousel({
    autoplay: false,
    autoplaySpeed: 0.35,
    loop: false,
    rewind: true,
    navText: ["", ""],
    navContainerClass: "rd-carousel__nav rd-carousel__nav--secondary",
    navClass: [
      "rd-carousel__nav__prev rd-carousel__nav__prev--secondary",
      "rd-carousel__nav__next rd-carousel__nav__next--secondary",
    ],
    navElement: "div",
    dotsClass: "rd-carousel__dots",
    dotClass: "rd-carousel__dots__item",
    items: 1,
    stagePadding: 0,
    responsive: {
      0: {
        items: 1,
        nav: true,
        dots: true,
      },
      768: {
        items: 3,
        margin: 15,
        nav: true,
        dots: false,
      },
      992: {
        items: 4,
        margin: 30,
      },
    },
  });

  // Слайдер изображений товара
  $("#js-product-gallery").owlCarousel({
    autoplay: false,
    autoplaySpeed: 0.35,
    loop: false,
    rewind: true,
    navText: ["", ""],
    navContainerClass: "rd-carousel__nav rd-carousel__nav--secondary",
    navClass: [
      "rd-carousel__nav__prev rd-carousel__nav__prev--secondary",
      "rd-carousel__nav__next rd-carousel__nav__next--secondary",
    ],
    navElement: "div",
    dotsClass: "rd-carousel__dots",
    dotClass: "rd-carousel__dots__item",
    items: 1,
    nav: true,
    dots: true,
    stagePadding: 0,
  });

  // Показ большого изображения в модалке галереи
  $(document).on('click', '.ekko-lightbox.modal.show .zoom', function() {
    const img = document.querySelector('.ekko-lightbox-item.show').children[0];
    const imgSrc = img.attributes.src.value;
    const bigImg = document.createElement('img');
    bigImg.src = imgSrc;
    const modal = document.querySelector('#rd-image-fullscreen');
    modal.querySelector('.image-fullscreen__container').appendChild(bigImg);
    $(modal).modal();
  });

  $(document).on('click', '#rd-image-fullscreen .close', function () {
    document.querySelector('#rd-image-fullscreen .image-fullscreen__container img').remove();
  });

  // Галерея изображений товара
  $(document).on("click", '[data-toggle="lightbox"]', function (e) {
    e.preventDefault();
    $(this).ekkoLightbox({
      alwaysShowClose: true,
      onShow: function (e) {
        const modal = e.target;
        const closeBtn = modal.querySelector('[data-dismiss="modal"]');
        const zoomBtn = document.createElement('button');
        zoomBtn.className = 'zoom mr-4 d-none';
        const modalBtnsDiv = document.createElement('div');
        modalBtnsDiv.className = "d-flex align-items-center justify-content-center";
        modal.querySelector('.modal-header').appendChild(modalBtnsDiv);
        modalBtnsDiv.appendChild(zoomBtn);
        modalBtnsDiv.appendChild(closeBtn);
      },
      onContentLoaded: function () {
        const modal = document.querySelector('.ekko-lightbox.modal');
        const slide = document.querySelector('.ekko-lightbox-item.show');
        const slideInner = slide.children;
        if (slideInner.length && slideInner[0].tagName === "IMG") {
          modal.querySelector('.zoom').classList.remove('d-none');
        } else {
          modal.querySelector('.zoom').classList.add('d-none');
        }
      }
    });
  });

  let collapseElem = $(".js-gallery-hidden-thumbnail-item");

  $(collapseElem)
    .on("show.bs.collapse", function () {
      let visibleContent = $(".js-gallery-more-photos");
      if (!$(visibleContent).hasClass("d-none")) {
        $(visibleContent).addClass("d-none");
      }
    })
    .on("hide.bs.collapse", function () {
      let hiddenContent = $(".js-gallery-more-photos");
      if ($(hiddenContent).hasClass("d-none")) {
        $(hiddenContent).removeClass("d-none");
      }
    });

  // Открытие/закрытие меню
  $("#js-menu-open").on("click", function (e) {
    // if ($(".rd-header__dropdown__menu").hasClass("d-block")) {
    //   $(".rd-header__dropdown__toggle__icon").removeClass("active");
    //   $(".rd-header__dropdown__menu__inner").animate({ height: 0 }, 300);
    //   $(".rd-header__dropdown__menu").animate({ height: 0 }, 300, function () {
    //     $(this).removeClass("d-block");
    //     $(this).style.
    //   });
    // } else {
    //   $(".rd-header__dropdown__toggle__icon").addClass("active");
    //   let innerHeigth = $(".rd-header__dropdown__menu__inner").css(
    //     "max-height"
    //   );
    //   $(".rd-header__dropdown__menu")
    //     .addClass("d-block")
    //     .animate({ height: innerHeigth }, 300);
    //   $(".rd-header__dropdown__menu__inner").animate(
    //     { height: innerHeigth },
    //     300
    //   );
    // }
    const menu = document.querySelector(".rd-header__dropdown__menu");
    const icon = document.querySelector(".rd-header__dropdown__toggle__icon");
    const menuInnerHeigth = [...menu.children].reduce((acc, child) => {
      return acc + child.clientHeight;
    }, 0);

    if (menu.clientHeight > 0) {
      icon.classList.remove("active")
      menu.style.maxHeight = "0px";
    } else {
      icon.classList.add("active")
      menu.style.maxHeight = menuInnerHeigth + "px";
    }
    e.stopPropagation();
  });

  // Показ/скрытие поиска
  $('.rd-header__blocks__item--search').on('click', function(e) {
    const search$ = $(e.target).parents('.rd-header__dropdown__menu').length != 0
      ? $(e.target).parents('.rd-header__dropdown__menu').find('.rd-search')
      : $('.rd-header').siblings('.rd-search');
    
    if (search$.hasClass('active')) {
      search$.animate({ height: 0 }, 300, function() {
        $(".rd-search__input").val('');
        $(this).find(".rd-search__results__title").empty();
        $(this).find(".rd-search__results__inner").empty();
        $(this).find(".rd-search__results__empty").addClass("d-none");
        $(this).find('.rd-search__results__loader').removeClass("active");
        $(this).find('.rd-search__results').addClass('d-none')
        $(this).removeClass('active');
      });
    } else {
      search$
        .addClass('active')
        .animate({ height: search$.find('.container').outerHeight() + 110 }, 300);
      search$.find('input').trigger('focus');
    }
    e.stopPropagation();
  });

  $('.rd-search__close').on('click', function(e) {
    if ($(".rd-search").hasClass('active')) {
      $(".rd-search").animate({ height: 0 }, 300, function() {
        $(".rd-search__input").val('');
        $(this).find(".rd-search__results__title").empty();
        $(this).find(".rd-search__results__inner").empty();
        $(this).find(".rd-search__results__empty").addClass("d-none");
        $(this).find('.rd-search__results__loader').removeClass("active");
        $(this).find('.rd-search__results').addClass('d-none')
        $(this).removeClass('active');
      });
    }
    e.stopPropagation();
  });

  // Закрытие менюи поиска при внешнем клике
  $(window).on("click", function (e) {
    if ($(e.target).parents(".rd-header__dropdown__menu").length == 0) {
      if ($(".rd-header__dropdown__menu").hasClass("d-block")) {
        $(".rd-header__dropdown__toggle__icon").removeClass("active");
        $(".rd-header__dropdown__menu__inner").animate({ height: 0 }, 300);
        $(".rd-header__dropdown__menu").animate(
          { height: 0 },
          300,
          function () {
            $(this).removeClass("d-block");
          }
        );
      }
    }

    if ($(e.target).parents(".rd-search").length == 0) {
      if ($(".rd-search").hasClass("active")) {
        $(".rd-search").animate({ height: 0 }, 300, function() {
          $(this).find(".rd-search__input").val('');
          $(this).find(".rd-search__results__title").empty();
          $(this).find(".rd-search__results__inner").empty();
          $(this).find(".rd-search__results__empty").addClass("d-none");
          $(this).find('.rd-search__results__loader').removeClass("active");
          $(this).find('.rd-search__results').addClass('d-none')
          $(this).removeClass('active');
        });
      }
    }
  });

  // Поиск
  let timeout = null;

  function search(value, $results) {
    if (timeout) {  
      clearTimeout(timeout);
    }
    timeout = setTimeout(function() {
      $results.removeClass("d-none");
      $results.find(".rd-search__results__inner").addClass('d-none')
      $results.find(".rd-search__results__empty").addClass("d-none");
      $results.find('.rd-search__results__loader').addClass("active");
      $.ajax({
        url: '/search',
        method: 'get',
        data: { query: value },
        dataType: 'json',
        success: function(data) {
          $results.find('.rd-search__results__loader').removeClass("active");
          $results
            .find(".rd-search__results__title")
            .html(`${$results.data("title")} «${value}»`);
          let html = '';
          if (data && data.length) {
            data.forEach((category) => {
              html += `
              <div class="rd-search__results__category">
                <a href="${category.url}" class="rd-search__results__category__title">
                  ${category.category_name} (<span>${category.total}</span>)
                </a>
              `;
              if (category.results && category.results.length) {
                category.results.forEach((product) => {
                  html += `
                    <a href="${product.url}" class="rd-search__results__category__item">
                      ${product.label}
                    </a>
                  `;
                });
              }
              html += `</div>`;
            });
          }

          if (html) {
            $results.find(".rd-search__results__inner").removeClass('d-none')
            $results.find(".rd-search__results__inner").html(html);
          } else {
            $results.find(".rd-search__results__inner").addClass('d-none')
            $results.find(".rd-search__results__empty").removeClass("d-none");
          }
        },
        error: function(error) {
          $results.find('.rd-search__results__loader').removeClass("active");
          $results.find(".rd-search__results__inner").addClass('d-none')
          $results.find(".rd-search__results__empty").removeClass("d-none");
          console.error(error);
        }
      });
    }, 500);
  }

  $(".rd-search__input").on("keyup", function(e) {
    const value = e.target.value;
    const $results = $(this).parents(".rd-search__inner").find(".rd-search__results");

    if (value) {
      search(value, $results);
    } else {
      $results.find(".rd-search__results__title").empty();
      $results.find(".rd-search__results__inner").empty();
      $results.find(".rd-search__results__empty").addClass("d-none");
      $results.next('.rd-search__results__loader').removeClass("active");
      $results.addClass("d-none");
    }
  });

  // Показ быстрых ссылок на странице товара
  let timeoutId = null;

  function hide() {
    $("#js-product-links").addClass("d-none");
    timeoutId = null;
  }

  $(window).on("scroll", function () {
    $("#js-product-links").removeClass("d-none");
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(hide, 2500);
  });

  // Обработка ссылок-якорей
  $(".js-anchor-link").on("click", function (e) {
    e.preventDefault();

    const target = $(this).attr("href");
    if (target && $(target).offset()) {
      const offset = window.matchMedia("(min-width: 768px)").matches ? 80 : 100;
      $("html, body").animate(
        { scrollTop: $(target).offset().top - offset },
        600
      );
    }
  });

  // Показ/скрытие товаров в категории по наведению в меню
  $(".rd-header__categories__item").on("mouseenter", function () {
    const id = $(this).data("category");
    $(".rd-header__categories__item").removeClass("active");
    $(this).addClass("active");
    $(this)
      .parents(".rd-header__dropdown__menu__inner")
      .find(".rd-header__categories__item__products")
      .each(function () {
        const parentId = $(this).data("category");
        if (id === parentId) {
          $(this).removeClass("d-none");
        } else {
          $(this).addClass("d-none");
        }
      });
  });

  // Показ/скрытие кнопки прокрутки к началу страницы + фиксация кнопок прокрутки и помощи к подвалу
  $(window).on("scroll", function () {
    const scrollTopBtn = $("#js-scroll-top");
    const helpBtn = $("#js-help");
    if ($(window).scrollTop() > 100) {
      scrollTopBtn.show();
    } else {
      scrollTopBtn.hide();
    }

    const scrollPosition = $(this).scrollTop() + $(this).height();
    const atBottom = scrollPosition < $(document).height() - $(".rd-footer").outerHeight();
    scrollTopBtn.toggleClass("position-fixed", atBottom);
    helpBtn.toggleClass("position-fixed", atBottom);
  });

  // Прокрутка к началу страницы
  $("#js-scroll-top").on("click", function () {
    $("html, body").animate({ scrollTop: 0 }, 600);
    return false;
  });

  // Выбор языка
  $("#js-locale-popover").popover({
    html: true,
    sanitize: false,
    container: "footer.rd-footer",
    placement: "left",
    content: $("#js-locales-tpl").html(),
    customClass: "rd-footer__locale__popover",
  });

  // Поворот иконки FAQ блока при открытии/закрытии
  $(".rd-faq__item__content").on(
    "show.bs.collapse hide.bs.collapse",
    function (e) {
      if ($(this).is(e.target)) {
        if (e.type === "show") {
          $(this)
            .parent()
            .find(".rd-faq__item__header__icon")
            .addClass("rotate-90");
        } else {
          $(this)
            .parent()
            .find(".rd-faq__item__header__icon")
            .removeClass("rotate-90");
          $(this).find(".collapse").collapse("hide");
        }
      }
    }
  );

  // Обработка формы обратной связи в модальном окне помощи
  $("#js-help-form").on("submit", function (e) {
    e.preventDefault();

    const helpModal$ = $("#js-helpModal");
    const successToast$ = $("#js-successToast");
    const errorToast$ = $("#js-errorToast");

    const form$ = $(this);
    const url = form$.attr("action");

    $.ajax({
      type: "POST",
      url: url,
      data: form$.serialize(),
      success: function (data) {
        form$.find("textarea#message").val("");
        helpModal$.modal('hide');
        successToast$
          .find(".toast-body")
          .html(data.message || successToast$.data('default-text'));
        successToast$.toast('show');
      },
      error: function (xhr) {
        try {
          const errorResp = JSON.parse(xhr.responseText);
          if (errorResp.errors) {
            Object.keys(errorResp.errors).forEach((key) => {
              let errorMsg = "";
              errorResp.errors[key].forEach((msg) => (errorMsg += msg + "\n"));
              form$.find("#" + key).addClass("is-invalid");
              form$
                .find("#" + key)
                .siblings(".invalid-feedback")
                .html(errorMsg || form$.data('field-error'));
            });
          }
        } catch (e) {
          errorToast$
            .find(".toast-body")
            .html(errorToast$.data('default-text'));
          errorToast$.toast('show');
        }
      },
    });
  });

  // Обработка переключения между вариантами товара на странице товара
  $(".rd-product__varieties__item__color").on("click", function() {
    const slug = $(this).data("product-slug");
    if (!$(this).hasClass("active") && slug) {
      window.location = slug;
    }
  });

  $(".rd-product__varieties__item input").on("change", function() {
    window.location = $(this).val();
  });

  // Автокролл к вопросу в FAQ
  const urlParams = new URLSearchParams(window.location.search);
  const faqItemId = urlParams.has('item') ? urlParams.get('item') : null;
  const faqItemQuestionId = urlParams.has('question') ? urlParams.get('question') : null;

  if (typeof faqItemId === 'string') {
    let faqQuestionEl$;
    const offset = window.matchMedia("(min-width: 768px)").matches ? 80 : 100;
    if (typeof faqItemQuestionId === 'string') {
      faqQuestionEl$ = $(`.rd-faq__item__questions__item__header[href="#rd-faq__item__questions__item__content-${faqItemId}-${faqItemQuestionId}"]`);
    } else {
      faqQuestionEl$ = $(`.rd-faq__item__header[href="#rd-faq__item__content-${faqItemId}-${faqItemQuestionId}"]`);
    }
    if (faqQuestionEl$ && faqQuestionEl$.length) {
      $("html, body").animate(
        { scrollTop: faqQuestionEl$.parent().offset().top - offset },
        600
      );
    }
  }
});
